import { z } from 'zod';
import { AMBITOS_ROL, CLAVES_ROL } from './comunes';

/**
 * Roles y permisos.
 *
 * ── Por qué acá NO se crean roles, y en Polaris sí ──
 * En Polaris el dueño del negocio define los roles que quiera. Acá no, y la
 * diferencia no es de gusto: el **ámbito** de un rol —`copathy`, `empresa`,
 * `trabajador`— es lo que usa `tg_usuarios_ambito_rol` para sostener la frontera
 * entre empresas. Un rol nuevo obliga a elegirle un ámbito, y elegirlo mal le
 * abre a alguien todas las empresas clientes sin ningún síntoma.
 *
 * Los cuatro roles llegan por migración y se editan **solo en qué permisos
 * tienen**. Si algún día hace falta un quinto, es una migración y una decisión
 * escrita, no un formulario.
 */

export const esquemaPermiso = z.object({
  id: z.number().int().positive(),
  clave: z.string(),
  descripcion: z.string(),
  /** Un rol de empresa o trabajador NUNCA puede tenerlo (D-006, D-009). */
  prohibidoParaEmpresa: z.boolean(),
});
export type PermisoInfo = z.infer<typeof esquemaPermiso>;

export const esquemaRol = z.object({
  id: z.number().int().positive(),
  clave: z.enum(CLAVES_ROL),
  nombre: z.string(),
  ambito: z.enum(AMBITOS_ROL),
  permisos: z.array(z.string()),
  /** Cuántas cuentas lo tienen. Es lo que dice si un cambio afecta a alguien. */
  usuarios: z.number().int(),
});
export type Rol = z.infer<typeof esquemaRol>;

/**
 * Se manda la lista COMPLETA de permisos del rol, no un «agregar» y un «quitar».
 *
 * Con dos operaciones sueltas, dos personas editando a la vez terminan con una
 * mezcla que ninguna de las dos pidió. Mandando el estado final, la última gana
 * —que es un resultado que alguien eligió— y además se puede comparar contra lo
 * que había para escribir el historial.
 */
export const esquemaFijarPermisos = z.object({
  permisos: z.array(z.string().min(1).max(60)).max(200),
});
export type EntradaFijarPermisos = z.infer<typeof esquemaFijarPermisos>;
